import { Button } from 'cwp-components/forms'

export const VerificationSuccess = ({ setStatus }) => {
  return (
    <div className='md:p-[60px] md:w-[900px] w-full md:h-[500px]  p-[20px] md:m-auto bg-white rounded-[20px]'>
      <div className='md:p-[30px] p-[10px]'>
        <h1 className='md:text-[24px] md:mb-[50px] mb-[20px] text-[16px] text-[#093269] font-bold '>
          ID verification
        </h1>
        <div className='flex items-start gap-[7px]'>
          <svg
            width='24'
            height='25'
            viewBox='0 0 24 25'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M11.9998 23.2106C17.9152 23.2106 22.7106 18.4152 22.7106 12.4998C22.7106 6.58443 17.9152 1.78906 11.9998 1.78906C6.08443 1.78906 1.28906 6.58443 1.28906 12.4998C1.28906 18.4152 6.08443 23.2106 11.9998 23.2106Z'
              fill='#58C1B3'
              stroke='#58C1B3'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M16.4654 9.82275L10.9727 15.1781'
              stroke='white'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M7.53906 11.3516L10.972 15.1767'
              stroke='white'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </svg>

          <div className='space-y-[13px] md:mb-[70px] mb-[30px]'>
            <h1 className='md:text-[18px] text-[14px] font-bold '>
              You're verified!
            </h1>
            <p className='md:text-[16px] text-[12px] font-[400] '>
              YOTI has now verified your identity and your verified profile will
              activate shortly.
            </p>
          </div>
        </div>
        <div className='flex justify-end gap-[20px]'>
          <Button
            onClick={() => setStatus('default')}
            className='bg-[#020251] text-white'
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  )
}
